/* AdvancedFIlterRenderer.js */

"use strict";

require("jQuery-QueryBuilder");
require("bootstrap");
window.interact = require("interactjs");

const EventEmitter = require("events");
const _ = require("lodash");
const $ = require("jquery");

const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;

class AdvancedFilterRenderer extends EventEmitter {
    constructor(model, options) {
        super();
        this._model = model;
        this._initialMongoQuery = _.get(options, "filterData", {});
        this._fieldsConfig = _.get(options, "fieldsConfig", []);
        this._allowGroups = _.get(options, "allowGroups", true);
        this._darkTheme = false;

        this._rootElem = document.createElement("advanced-filter-gl");

        if (_.get(this._model, "_type.name", "") === "special") {
            this._rootElem.classList.add("special-filter");
        }

        this._builderContainer = document.createElement("div");

        this.resetBtn = new ButtonControl({label: "Reset", darkTheme: true});
        this.applyBtn = new ButtonControl({label: "Apply", darkTheme: true});
        this.closeBtn = new ButtonControl({label: "Close", darkTheme: true});
        this._hiddenInput = this._createHiddenInput();

        this._buttonControlContainer = document.createElement("button-control-container");

        this._resetQueryBuilder = this._resetQueryBuilder.bind(this);
        this._applyQuery = this._applyQuery.bind(this);
        this._closeFilter = this._closeFilter.bind(this);
        this._onBeforeDeleteRule = this._onBeforeDeleteRule.bind(this);
        this._onAfterDelete = this._onAfterDelete.bind(this);
        this._onSetQuery = this._onSetQuery.bind(this);
        this._onUpdateHeight = this._onUpdateHeight.bind(this);
        this._onRuleChanged = this._onRuleChanged.bind(this);

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _emitMongoQueryChanged(mongoQuery) {
        this.emit("AdvancedFilterUserChanged", mongoQuery);
    }

    _emitCloseAdvancedFilter() {
        this.emit("AdvancedFilterUserClose");
    }

    _emitUnregisterInput(name) {
        this.emit("UnregisterInput", name);
    }

    _registerListeners() {
        this.resetBtn.on("UserClick", this._resetQueryBuilder);
        this.applyBtn.on("UserClick", this._applyQuery);
        this.closeBtn.on("UserClick", this._closeFilter);

        this.model.on("SetQuery", this._onSetQuery);
        this.model.on("UpdateHeight", this._onUpdateHeight);
    }

    _registerBuilderListeners() {
        this.$builderContainer
            .on("beforeDeleteRule.queryBuilder", this._onBeforeDeleteRule)
            .on("afterDeleteRule.queryBuilder", this._onAfterDelete)
            .on("afterDeleteGroup.queryBuilder", this._onAfterDelete)
            .on("rulesChanged.queryBuilder", this._onRuleChanged);
    }

    _unregisterListeners() {
        this.resetBtn.removeListener("UserClick", this._resetQueryBuilder);
        this.applyBtn.removeListener("UserClick", this._applyQuery);
        this.closeBtn.removeListener("UserClick", this._closeFilter);

        this.model.removeListener("SetQuery", this._onSetQuery);
        this.model.removeListener("UpdateHeight", this._onUpdateHeight);
    }

    render() {
        const btnGroup = document.createElement("div");

        btnGroup.classList.add("button-control-container");

        btnGroup.appendChild(this.resetBtn.renderer.rootElement);
        btnGroup.appendChild(this.applyBtn.renderer.rootElement);
        btnGroup.appendChild(this.closeBtn.renderer.rootElement);

        return new Promise((resolve /*,reject*/) => {
            this._rootElem.dataset.darkTheme = this._darkTheme;
            this._rootElem.innerHTML = "";
            this._rootElem.appendChild(this._hiddenInput);
            this._rootElem.appendChild(this._builderContainer);

            this._rootElem.appendChild(this._buttonControlContainer);
            this._buttonControlContainer.appendChild(this.resetBtn.renderer.rootElement);
            this._buttonControlContainer.appendChild(this.applyBtn.renderer.rootElement);

            if (_.get(this._model, "_type.name", "") === "special") {
                this._createSpecialBuilder();
            } else {
                this._createBuilder();
            }
            this._setQuery(this._initialMongoQuery);

            resolve();
        }).catch(console.warn.bind(console, "advancedFilter render error:"));
    }

    shutdown() {
        this.$builderContainer.queryBuilder("destroy");
        this._unregisterListeners();
        this._rootElem.innerHTML = "";

        return Promise.all([
            this.resetBtn.shutdown(),
            this.applyBtn.shutdown(),
            this.closeBtn.shutdown(),
        ])
            .then(() => {
                this._model = null;
                this._rootElem = null;
                this._initialMongoQuery = null;
                this.resetBtn = null;
                this.applyBtn = null;
                this.closeBtn = null;
            })
            .catch(console.warn.bind(console, "advancedFilter shutdown error:"));
    }

    _createHiddenInput() {
        const input = document.createElement("input");
        input.setAttribute("type", "text");
        input.setAttribute("tabindex", "-1");
        input.classList.add("keep-focus-input");

        return input;
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    getModel() {
        return this._model;
    }

    get model() {
        return this.getModel();
    }

    get $builderContainer() {
        return this.getBuilderContainer();
    }

    getBuilderContainer() {
        return $(this._builderContainer);
    }

    /*******************************************/
    /* END PUBLIC COMPONENT RENDERER METHODS   */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onBeforeDeleteRule(e, rule) {
        this._emitUnregisterInput(rule.id);
    }

    _onAfterDelete(/*e, rule*/) {
        this._hiddenInput.focus();
        if (this._isQueryEmpty({skip_empty: false})) {
            if (!_.isEmpty(this._model._type)) {
                this._createSpecialBuilder();
            } else {
                this._createBuilder();
            }
        }
    }

    _onSetQuery(query) {
        this._setQuery(query);
    }

    _onUpdateHeight(parentHeight) {
        parentHeight = parseInt(parentHeight);
        const buttonsHeight = this._buttonControlContainer.offsetHeight;
        const buttonsStyles = getComputedStyle(this._buttonControlContainer);

        const margins = parseInt(buttonsStyles.marginTop) + parseInt(buttonsStyles.marginBottom);

        this._builderContainer.style.maxHeight = `${parentHeight - (buttonsHeight + margins)}px`;
    }

    _onRuleChanged(event) {
        this.model.emit("AdvancedFilterRuleChanged", event);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */

    /*******************************************/

    _createBuilder() {
        this.$builderContainer.queryBuilder("destroy");
        this.$builderContainer.queryBuilder.regional.en.operators.longstring_begins_with =
            "begins with";
        this.$builderContainer.queryBuilder.regional.en.operators.longstring_not_begins_with =
            "doesn't begin with";
        this.$builderContainer.queryBuilder.regional.en.operators.longstring_ends_with =
            "ends with";
        this.$builderContainer.queryBuilder.regional.en.operators.longstring_not_ends_with =
            "doesn't end with";
        this.$builderContainer.queryBuilder.regional.en.operators.string_contains_regex =
            "contains (regex)";
        this.$builderContainer.queryBuilder.regional.en.operators.string_doesnt_contains_regex =
            "doesn't contain (regex)";
        this.$builderContainer.queryBuilder.regional.en.operators.string_equals_regex =
            "equal (regex)";
        this.$builderContainer.queryBuilder.regional.en.operators.string_not_equals_regex =
            "not equal (regex)";

        this.$builderContainer.queryBuilder.regional.en.operators.pathlist_equals = "equal";
        this.$builderContainer.queryBuilder.regional.en.operators.pathlist_not_equals = "not equal";

        this.$builderContainer.queryBuilder.regional.en.operators.array_includes = "includes";
        this.$builderContainer.queryBuilder.regional.en.operators.array_not_includes =
            "doesn't include";

        Object.assign(this.$builderContainer.queryBuilder.constructor.types, {duration: "number"});

        this.$builderContainer.queryBuilder(this._getQueryBuilderOptions());

        this._extendQueryBuilder();

        this._registerBuilderListeners();
    }

    _createSpecialBuilder() {
        this.$builderContainer.queryBuilder("destroy");
        this.$builderContainer.queryBuilder.regional.en.operators.must_contain_regex =
            "must contain (regex)";
        this.$builderContainer.queryBuilder.regional.en.operators.must_not_contain_regex =
            "must not contain (regex)";
        this.$builderContainer.queryBuilder.regional.en.operators.must_not_contain_ordered_regex =
            "must not contain, ordered (regex)";
        this.$builderContainer.queryBuilder.regional.en.operators.must_only_contain_regex =
            "must only contain (regex)";
        this.$builderContainer.queryBuilder.regional.en.operators.must_contain_ordered_regex =
            "must contain, ordered (regex)";
        this.$builderContainer.queryBuilder.regional.en.operators.must_only_contain_ordered_regex =
            "must only contain, ordered (regex)";
        this.$builderContainer.queryBuilder.regional.en.operators.must_contain = "must contain";
        this.$builderContainer.queryBuilder.regional.en.operators.must_not_contain =
            "must not contain";
        this.$builderContainer.queryBuilder.regional.en.operators.must_not_contain_ordered =
            "must not contain, ordered";
        this.$builderContainer.queryBuilder.regional.en.operators.must_only_contain =
            "must only contain";
        this.$builderContainer.queryBuilder.regional.en.operators.must_contain_ordered =
            "must contain, ordered";
        this.$builderContainer.queryBuilder.regional.en.operators.must_only_contain_ordered =
            "must only contain, ordered";
        this.$builderContainer.queryBuilder.regional.en.operators.must_be_empty = "must be empty";
        this.$builderContainer.queryBuilder(this._getSpecialQueryBuilderOptions());

        this._extendQueryBuilder();

        this._registerBuilderListeners();
    }

    /* eslint-disable */

    /* jshint ignore:start */
    _extendQueryBuilder() {
        const rulesForExists = [
            "not_equal",
            "not_begins_with",
            "not_contains",
            "not_between",
            "not_ends_with",
            "is_empty",
            "longstring_not_begins_with",
            "longstring_not_ends_with",
            "string_not_equals_regex",
            "string_doesnt_contains_regex",
            "pathlist_not_equals",
            "array_not_includes",
        ];
        this.$builderContainer.queryBuilder.extend(
            /** @lends module:plugins.MongoDbSupport.prototype */ {
                /**
                 * Returns rules as a MongoDB query
                 * @param {object} [data] - current rules by default
                 * @returns {object}
                 * @fires module:plugins.MongoDbSupport.changer:getMongoDBField
                 * @fires module:plugins.MongoDbSupport.changer:ruleToMongo
                 * @fires module:plugins.MongoDbSupport.changer:groupToMongo
                 * @throws UndefinedMongoConditionError, UndefinedMongoOperatorError
                 */
                getMongo: function (data) {
                    data = data === undefined ? this.getRules() : data;

                    if (!data) {
                        return null;
                    }

                    const daysToMilliseconds = (days) => days * 24 * 60 * 60 * 1000;

                    var self = this;

                    return (function parse(group) {
                        if (!group.condition) {
                            group.condition = self.settings.default_condition;
                        }
                        if (["AND", "OR"].indexOf(group.condition.toUpperCase()) === -1) {
                            Utils.error(
                                "UndefinedMongoCondition",
                                'Unable to build MongoDB query with condition "{0}"',
                                group.condition
                            );
                        }

                        if (!group.rules) {
                            return {};
                        }

                        var parts = [];

                        group.rules.forEach(function (rule) {
                            if (rule.rules && rule.rules.length > 0) {
                                parts.push(parse(rule));
                            } else {
                                var mdb = self.settings.mongoOperators[rule.operator];
                                var ope = self.getOperatorByType(rule.operator);

                                if (mdb === undefined) {
                                    Utils.error(
                                        "UndefinedMongoOperator",
                                        'Unknown MongoDB operation for operator "{0}"',
                                        rule.operator
                                    );
                                }

                                if (ope.nb_inputs !== 0) {
                                    if (!(rule.value instanceof Array)) {
                                        rule.value = [rule.value];

                                        if (rule.type === "duration") {
                                            if (rule.operator === "equal") {
                                                rule.value = [
                                                    "equal",
                                                    daysToMilliseconds(parseInt(rule.value || 0)),
                                                    daysToMilliseconds(parseInt(rule.value || 0)) +
                                                        86399999,
                                                ];
                                            } else if (rule.operator === "not_equal") {
                                                rule.value = [
                                                    "not_equal",
                                                    daysToMilliseconds(parseInt(rule.value || 0)),
                                                    daysToMilliseconds(parseInt(rule.value || 0)) +
                                                        86399999,
                                                ];
                                            } else {
                                                rule.value = [
                                                    daysToMilliseconds(parseInt(rule.value || 0)),
                                                ];
                                            }
                                        }
                                    } else {
                                        if (rule.type === "duration") {
                                            rule.value[0] = daysToMilliseconds(
                                                parseInt(rule.value[0] || 0)
                                            );
                                            rule.value[1] = daysToMilliseconds(
                                                parseInt(rule.value[1] || 0)
                                            );
                                        }
                                    }
                                }

                                /**
                                 * Modifies the MongoDB field used by a rule
                                 * @event changer:getMongoDBField
                                 * @memberof module:plugins.MongoDbSupport
                                 * @param {string} field
                                 * @param {Rule} rule
                                 * @returns {string}
                                 */
                                var field = self.change("getMongoDBField", rule.field, rule);

                                var ruleExpression = {};

                                ruleExpression[field] = mdb.call(self, rule.value);
                                /*
                  add $or and $exists for negative conditions
              */
                                if (rulesForExists.includes(rule.operator)) {
                                    var tempRule = {};
                                    tempRule[field] = {$exists: false};
                                    ruleExpression = {
                                        $or: [ruleExpression, tempRule],
                                    };
                                }

                                /**
                                 * Modifies the MongoDB expression generated for a rul
                                 * @event changer:ruleToMongo
                                 * @memberof module:plugins.MongoDbSupport
                                 * @param {object} expression
                                 * @param {Rule} rule
                                 * @param {*} value
                                 * @param {function} valueWrapper - function that takes the value and adds the operator
                                 * @returns {object}
                                 */
                                parts.push(
                                    self.change(
                                        "ruleToMongo",
                                        ruleExpression,
                                        rule,
                                        rule.value,
                                        mdb
                                    )
                                );
                            }
                        });

                        var groupExpression = {};
                        groupExpression["$" + group.condition.toLowerCase()] = parts;

                        /**
                         * Modifies the MongoDB expression generated for a group
                         * @event changer:groupToMongo
                         * @memberof module:plugins.MongoDbSupport
                         * @param {object} expression
                         * @param {Group} group
                         * @returns {object}
                         */
                        return self.change("groupToMongo", groupExpression, group);
                    })(data);
                },
                /* Gets operators from settings - Override */
                getMongoOperator: function (data) {
                    if (data !== null && typeof data === "object") {
                        if (data.$gte !== undefined && data.$lte !== undefined) {
                            return "between";
                        }
                        if (data.$lt !== undefined && data.$gt !== undefined) {
                            return "not_between";
                        }
                        if (data.$gte !== undefined && data.$lt !== undefined) {
                            return "$eq";
                        }
                        if (
                            data.$not &&
                            _.get(data.$not, "$gt", undefined) !== undefined &&
                            _.get(data.$not, "$lte", undefined) !== undefined
                        ) {
                            return "$ne";
                        }

                        var knownKeys = Object.keys(data).filter(
                            function (key) {
                                return !!this.settings.mongoRuleOperators[key];
                            }.bind(this)
                        );

                        if (knownKeys.length === 1) {
                            return knownKeys[0];
                        }
                    } else {
                        return "$eq";
                    }
                },

                /**
                 * Converts a MongoDB query to rules
                 * @param {object} query
                 * @returns {object}
                 * @fires module:plugins.MongoDbSupport.changer:parseMongoNode
                 * @fires module:plugins.MongoDbSupport.changer:getMongoDBFieldID
                 * @fires module:plugins.MongoDbSupport.changer:mongoToRule
                 * @fires module:plugins.MongoDbSupport.changer:mongoToGroup
                 * @throws MongoParseError, UndefinedMongoConditionError, UndefinedMongoOperatorError
                 */
                getRulesFromMongo: function (query) {
                    if (query === undefined || query === null) {
                        return null;
                    }

                    var self = this;

                    /**
                     * Custom parsing of a MongoDB expression, you can return a sub-part of the expression, or a well formed group or rule JSON
                     * @event changer:parseMongoNode
                     * @memberof module:plugins.MongoDbSupport
                     * @param {object} expression
                     * @returns {object} expression, rule or group
                     */
                    query = self.change("parseMongoNode", query);

                    // a plugin returned a group
                    if ("rules" in query && "condition" in query) {
                        return query;
                    }

                    // a plugin returned a rule
                    if ("id" in query && "operator" in query && "value" in query) {
                        return {
                            condition: this.settings.default_condition,
                            rules: [query],
                        };
                    }

                    var key = self.getMongoCondition(query);
                    if (!key) {
                        Utils.error("MongoParse", "Invalid MongoDB query format");
                    }

                    return (function parse(data, topKey) {
                        var rules = data[topKey];
                        var parts = [];

                        function cleanGroups(data, key) {
                            var removeGroup = false;
                            if (key === "$or") {
                                data[key] = data[key].filter((rule) => {
                                    const ruleVal = Object.values(rule)[0];
                                    if (typeof ruleVal === "object" && "$exists" in ruleVal) {
                                        removeGroup = true;
                                        return false;
                                    }
                                    return true;
                                });
                            }
                            if (removeGroup && key && data[key].length < 2) {
                                data = data[key][0];
                                const childKey = Object.keys(data)[0];
                                if (childKey === "$or" || childKey === "$and") {
                                    return cleanGroups(data, childKey);
                                }
                                return cleanGroups(data);
                            }
                            // console.log({ key, data });
                            return {key, data};
                        }

                        rules.forEach(function (data) {
                            // allow plugins to manually parse or handle special cases
                            data = self.change("parseMongoNode", data);

                            // a plugin returned a group
                            if ("rules" in data && "condition" in data) {
                                parts.push(data);
                                return;
                            }

                            // a plugin returned a rule
                            if ("id" in data && "operator" in data && "value" in data) {
                                parts.push(data);
                                return;
                            }

                            var key = self.getMongoCondition(data);
                            var temp = cleanGroups(data, key);
                            key = temp.key;
                            data = temp.data;

                            if (key) {
                                parts.push(parse(data, key));
                            } else {
                                var field = Object.keys(data)[0];
                                var value = data[field];
                                if (typeof value === "object" && "$exists" in value) {
                                    return;
                                }
                                var operator = self.getMongoOperator(value);
                                if (operator === undefined) {
                                    Utils.error("MongoParse", "Invalid MongoDB query format");
                                }

                                var mdbrl = self.settings.mongoRuleOperators[operator];
                                if (mdbrl === undefined) {
                                    Utils.error(
                                        "UndefinedMongoOperator",
                                        'JSON Rule operation unknown for operator "{0}"',
                                        operator
                                    );
                                }

                                var opVal = mdbrl.call(self, value, field);

                                var id = self.getMongoDBFieldID(field, value);

                                /**
                                 * Modifies the rule generated from the MongoDB expression
                                 * @event changer:mongoToRule
                                 * @memberof module:plugins.MongoDbSupport
                                 * @param {object} rule
                                 * @param {object} expression
                                 * @returns {object}
                                 */
                                var rule = self.change(
                                    "mongoToRule",
                                    {
                                        id: id,
                                        field: field,
                                        operator: opVal.op,
                                        value: opVal.val,
                                    },
                                    data
                                );

                                parts.push(rule);
                            }
                        });

                        /**
                         * Modifies the group generated from the MongoDB expression
                         * @event changer:mongoToGroup
                         * @memberof module:plugins.MongoDbSupport
                         * @param {object} group
                         * @param {object} expression
                         * @returns {object}
                         */
                        return self.change(
                            "mongoToGroup",
                            {
                                condition: topKey.replace("$", "").toUpperCase(),
                                rules: parts,
                            },
                            data
                        );
                    })(query, key);
                },
            }
        );
    }

    /* jshint ignore:end */

    /* eslint-enable */

    _getQueryBuilderOptions() {
        const escapeRegExp = (str) =>
            typeof str === "string" ? str.replace(/[\\[\]/{}()*+?.^$|-]/g, "\\$&") : str;
        const unEscapeRegExp = (str) =>
            typeof str === "string" ? str.replace(/\\([\\[\]/{}()*+?.^$|-])/g, "$1") : str;

        const escapeDefaultValues = (str) => {
            let strToReturn = str.substring(0, 1) === "^" ? str.replace(/^./, "^") : str;
            strToReturn =
                strToReturn.substring(strToReturn.length - 1) === "$"
                    ? strToReturn.replace(/.$/, "$")
                    : strToReturn;
            return strToReturn;
        };

        const emptyValuesArray = [null, "", false];
        const arrayIsEmptyValues = (array) =>
            array.length === emptyValuesArray.length &&
            !_.difference(array, emptyValuesArray).length;

        const isArrayIncludesField = (queryBuilder, field) => {
            const filter = queryBuilder.getFilterById(field, false);
            return _.get(filter, "operators", []).includes("array_includes");
        };

        const options = {
            //plugins: ['bt-tooltip-errors'],
            allow_empty: true,
            operators: [
                {type: "equal"},
                {
                    type: "string_equals_regex",
                    nb_inputs: 1,
                    multiple: false,
                    apply_to: ["string"],
                },
                {type: "not_equal"},
                {
                    type: "string_not_equals_regex",
                    nb_inputs: 1,
                    multiple: false,
                    apply_to: ["string"],
                },
                {type: "less"},
                {type: "less_or_equal"},
                {type: "greater"},
                {type: "greater_or_equal"},
                {type: "between"},
                {type: "not_between"},
                {type: "begins_with"},
                {type: "not_begins_with"},
                {type: "contains"},
                {
                    type: "string_contains_regex",
                    nb_inputs: 1,
                    multiple: false,
                    apply_to: ["string"],
                },
                {type: "not_contains"},
                {
                    type: "string_doesnt_contains_regex",
                    nb_inputs: 1,
                    multiple: false,
                    apply_to: ["string"],
                },
                {type: "ends_with"},
                {type: "not_ends_with"},
                {
                    type: "is_empty",
                    nb_inputs: 0,
                    multiple: false,
                    apply_to: ["string", "number", "datetime", "boolean", "duration"],
                },
                {
                    type: "is_not_empty",
                    nb_inputs: 0,
                    multiple: false,
                    apply_to: ["string", "number", "datetime", "boolean", "duration"],
                },
                {
                    type: "longstring_begins_with",
                    nb_inputs: 1,
                    multiple: false,
                    apply_to: ["longstring"],
                },
                {
                    type: "longstring_not_begins_with",
                    nb_inputs: 1,
                    multiple: false,
                    apply_to: ["longstring"],
                },
                {
                    type: "longstring_ends_with",
                    nb_inputs: 1,
                    multiple: false,
                    apply_to: ["longstring"],
                },
                {
                    type: "longstring_not_ends_with",
                    nb_inputs: 1,
                    multiple: false,
                    apply_to: ["longstring"],
                },
                {type: "pathlist_equals", nb_inputs: 1, multiple: false, apply_to: ["pathlist"]},
                {
                    type: "pathlist_not_equals",
                    nb_inputs: 1,
                    multiple: false,
                    apply_to: ["pathlist"],
                },
                {type: "array_includes", nb_inputs: 1, multiple: false, apply_to: ["array"]},
                {
                    type: "array_not_includes",
                    nb_inputs: 1,
                    multiple: false,
                    apply_to: ["array"],
                },
            ],
            mongoOperators: {
                equal: (v) => {
                    if (v.length === 3 && v[0] === "equal") {
                        return {$gte: v[1], $lt: v[2]};
                    }
                    return typeof v[0] === "string" ? {$eq: v[0]} : v[0];
                },
                not_equal: (v) => {
                    if (v.length === 3 && v[0] === "not_equal") {
                        // return { '$lte': v[1], '$gt': v[2] }
                        return {
                            $not: {$gt: escapeRegExp(v[1]), $lte: escapeRegExp(v[2])},
                        };
                    }
                    return {$ne: v[0]};
                },
                begins_with: (v) => ({
                    $regex: "^(" + escapeDefaultValues(escapeRegExp(v[0])) + ")",
                    $options: "mi",
                }),
                not_begins_with: (v) => ({
                    $regex: "^(?!" + escapeDefaultValues(escapeRegExp(v[0])) + ")",
                    $options: "mi",
                }),
                contains: (v) => ({
                    $regex: escapeDefaultValues(escapeRegExp(v[0])),
                    $options: "mi",
                }),
                not_contains: (v) => ({
                    $not: {
                        $regex: "(" + escapeDefaultValues(escapeRegExp(v[0])) + ")",
                        $options: "mi",
                    },
                }),
                ends_with: (v) => ({
                    $regex: "(" + escapeDefaultValues(escapeRegExp(v[0])) + ")$",
                    $options: "mi",
                }),
                not_ends_with: (v) => ({
                    $regex: "(?<!" + escapeDefaultValues(escapeRegExp(v[0])) + ")$",
                    $options: "mi",
                }),
                is_empty: () => ({$in: [null, "", false]}),
                is_not_empty: () => {
                    return {$nin: [null, "", false]};
                },
                not_between: (v) => ({
                    $not: {$gt: escapeRegExp(v[0]), $lt: escapeRegExp(v[1])},
                }),
                longstring_begins_with: (v) => ({
                    $regex: "(^|(\\r?\\n))" + escapeRegExp(v[0]),
                    $options: "i",
                }),
                longstring_not_begins_with: (v) => ({
                    $not: {
                        $regex: "(^|(\\r?\\n))" + escapeRegExp(v[0]),
                        $options: "i",
                    },
                    $exists: true,
                }),
                longstring_ends_with: (v) => ({
                    $regex: escapeRegExp(v[0]) + "((\\r?\\n)|$)",
                    $options: "i",
                }),
                longstring_not_ends_with: (v) => ({
                    $not: {
                        $regex: escapeRegExp(v[0]) + "((\\r?\\n)|$)",
                        $options: "i",
                    },
                    $exists: true,
                }),
                string_equals_regex: (v) => ({
                    $regex: "^(" + escapeDefaultValues(v[0]) + ")$",
                    $options: "i",
                }),
                less_or_equal: (v) => {
                    return {$lte: v[0]};
                },
                string_not_equals_regex: (v) => ({
                    $regex: "^((?!" + escapeDefaultValues(v[0]) + "$))",
                    $options: "i",
                }),
                string_contains_regex: (v) => ({
                    $regex: "(((" + escapeDefaultValues(v[0]) + ")))",
                    $options: "mi",
                }),
                string_doesnt_contains_regex: (v) => ({
                    $not: {
                        $regex: "((" + escapeDefaultValues(v[0]) + "))",
                        $options: "mi",
                    },
                }),
                pathlist_equals: (v) =>
                    v[0] !== "null"
                        ? {$in: ["pathList", v[0]]}
                        : {$in: ["pathList", null, "", false]},
                pathlist_not_equals: (v) =>
                    v[0] !== "null"
                        ? {$nin: ["pathList", v[0]]}
                        : {$nin: ["pathList", null, "", false]},
                array_includes: (v) => ({$eq: v[0]}),
                array_not_includes: (v) => ({$ne: v[0]}),
            },
            mongoRuleOperators: {
                $regex: function (v) {
                    v = v.$regex;
                    if (v.slice(0, 4) === "^(?!" && v.slice(-1) === ")") {
                        v = unEscapeRegExp(v);
                        return {val: v.slice(4, -1), op: "not_begins_with"};
                    } else if (v.slice(0, 3) === "(((" && v.slice(-3) === ")))") {
                        return {val: v.slice(3, -3), op: "string_contains_regex"};

                        // ---
                        // Legacy format of string_doesnt_contains_regex - To be eventually removed
                    } else if (
                        v.slice(0, 12) === "(?<!\n)^(((?!" &&
                        v.slice(-11) === ").))*$(?!\n)"
                    ) {
                        return {val: v.slice(12, -11), op: "string_doesnt_contains_regex"};
                        // ---
                        // Legacy format of string_doesnt_contains_regex - To be eventually removed
                    } else if (
                        v.slice(0, 12) === "(?<!\\n)^((?!" &&
                        v.slice(-11) === ").)*$(?!\\n)"
                    ) {
                        return {val: v.slice(12, -11), op: "string_doesnt_contains_regex"};
                        // ---
                        // Legacy format of not_contains - To be eventually removed
                    } else if (v.slice(0, 5) === "^((?!" && v.slice(-5) === ").)*$") {
                        v = unEscapeRegExp(v);
                        return {val: v.slice(5, -5), op: "not_contains"};
                    } else if (v.slice(0, 4) === "(?<!" && v.slice(-2) === ")$") {
                        v = unEscapeRegExp(v);
                        return {val: v.slice(4, -2), op: "not_ends_with"};
                    } else if (v.slice(0, 2) === "^(" && v.slice(-2) === ")$") {
                        if (
                            v.slice(2, -2) === "undefined" ||
                            v.slice(2, -2) === undefined ||
                            v.slice(2, -2) === "" ||
                            v.slice(2, -2) === null ||
                            v.slice(2, -2) === "null" ||
                            v.slice(2, -2) === "Blank"
                        ) {
                            v = unEscapeRegExp(v);
                            return {val: v.slice(2, -2), op: "is_empty"};
                        }
                        return {val: v.slice(2, -2), op: "string_equals_regex"};
                    } else if (v.slice(0, 5) === "^((?!" && v.slice(-3) === "$))") {
                        return {val: v.slice(5, -3), op: "string_not_equals_regex"};
                    } else if (v.slice(0, 1) === "(" && v.slice(-2) === ")$") {
                        v = unEscapeRegExp(v);
                        return {val: v.slice(1, -2), op: "ends_with"};
                    } else if (v.slice(0, 2) === "^(" && v.slice(-1) === ")") {
                        v = unEscapeRegExp(v);
                        return {val: v.slice(2, -1), op: "begins_with"};

                        // ---
                        // Legacy format of longstring_begins_with and longstring_ends_with - To be eventually removed
                    } else if (v.slice(0, 10) === "(^|(\\r\\n))") {
                        v = unEscapeRegExp(v);
                        return {val: v.slice(10), op: "longstring_begins_with"};
                    } else if (v.slice(-10) === "((\\r\\n)|$)") {
                        v = unEscapeRegExp(v);
                        return {val: v.slice(0, -10), op: "longstring_ends_with"};
                        // ---
                    } else if (v.slice(0, 11) === "(^|(\\r?\\n))") {
                        v = unEscapeRegExp(v);
                        return {val: v.slice(11), op: "longstring_begins_with"};
                    } else if (v.slice(-11) === "((\\r?\\n)|$)") {
                        v = unEscapeRegExp(v);
                        return {val: v.slice(0, -11), op: "longstring_ends_with"};
                    } else if (v.slice(0, 4) === "^(?!" && v.slice(-5) === "$).*$") {
                        v = unEscapeRegExp(v);
                        return {val: v.slice(4, -5), op: "not_equal"};
                    } else {
                        v = unEscapeRegExp(v);
                        return {val: v, op: "contains"};
                    }
                },
                $not: function (v) {
                    if (!_.isUndefined(_.get(v, "$not.$gt"))) {
                        return {
                            val: [_.get(v, "$not.$gt"), _.get(v, "$not.$lt")],
                            op: "not_between",
                        };
                    }
                    v = unEscapeRegExp(_.get(v, "$not.$regex"));

                    // Check for string_doesnt_contains_regex (2 opening parens)
                    if (v.slice(0, 2) === "((" && v.slice(-2) === "))") {
                        return {val: v.slice(2, -2), op: "string_doesnt_contains_regex"};
                    }
                    // Check for not_contains (1 opening paren)
                    if (v.slice(0, 1) === "(" && v.slice(-1) === ")") {
                        return {val: v.slice(1, -1), op: "not_contains"};
                    }

                    // ---
                    // Legacy format of longstring_not_begins_with and longstring_not_ends_with - To be eventually removed
                    if (v.slice(0, 10) === "(^|(\\r\\n))") {
                        return {val: v.slice(10), op: "longstring_not_begins_with"};
                    } else if (v.slice(-10) === "((\\r\\n)|$)") {
                        return {val: v.slice(0, -10), op: "longstring_not_ends_with"};
                        // ---
                    } else if (v.slice(0, 11) === "(^|(\\r?\\n))") {
                        return {val: v.slice(11), op: "longstring_not_begins_with"};
                    } else if (v.slice(-10) === "((\\r?\\n)|$)") {
                        return {val: v.slice(0, -11), op: "longstring_not_ends_with"};
                    }
                },
                $in: function (v) {
                    const val = [].concat(v.$in);

                    let op = arrayIsEmptyValues(val) ? "is_empty" : "in";

                    if (val && val[0] === "pathList") {
                        return {val: val[1] === null ? "null" : val[1], op: "pathlist_equals"};
                    }

                    return {val, op};
                },
                $nin: function (v) {
                    const val = [].concat(v.$nin);
                    let op = arrayIsEmptyValues(val) ? "is_not_empty" : "not_in";

                    if (val && val[0] === "pathList") {
                        return {
                            val: val[1] === null ? "null" : val[1],
                            op: "pathlist_not_equals",
                        };
                    }

                    return {val, op};
                },
                $eq: function (v, field) {
                    v = _.get(v, "$eq", v);
                    let op;
                    switch (v) {
                        case null:
                        case "null":
                        case "":
                        case "undefined":
                        case "Blank":
                            op = "is_empty";
                            break;
                        case true:
                        case false:
                        case "true":
                        case "false":
                            op = "equal";
                            v = _.toBool(v);
                            break;
                        default:
                            op = isArrayIncludesField(this, field) ? "array_includes" : "equal";
                    }
                    // if(typeof v === 'number') {
                    //     op = "equal";
                    // }

                    return {val: v, op: op};
                },
                $ne: function (v, field) {
                    v = _.get(v, "$ne", v);
                    let op;
                    switch (v) {
                        case null:
                        case "null":
                        case "":
                        case "undefined":
                        case "Blank":
                            op = "is_not_empty";
                            break;
                        default:
                            op = isArrayIncludesField(this, field)
                                ? "array_not_includes"
                                : "not_equal";
                    }
                    // if(typeof v === 'number') {
                    //     op = "not_equal";
                    // }
                    return {val: v, op: op};
                },
            },
            lang: {
                operators: {equal: "equal", not_equal: "not equal"},
            },
        };
        options.allow_groups = this._allowGroups;
        options.filters = _.uniqBy(this._fieldsConfig, "id");

        return options;
    }

    _getSpecialQueryBuilderOptions() {
        const escapeRegExp = (str) =>
            typeof str === "string" ? str.replace(/[\\[\]/{}()*+?.^$|-]/g, "\\$&") : str;
        const unEscapeRegExp = (str) =>
            typeof str === "string" ? str.replace(/\\([\\[\]/{}()*+?.^$|-])/g, "$1") : str;

        // const emptyValuesArray = [null, "", false];
        // const arrayIsEmptyValues = (array) => (array.length === emptyValuesArray.length && !_.difference(array, emptyValuesArray).length);

        const options = {
            //plugins: ['bt-tooltip-errors'],
            allow_empty: true,
            operators: [
                {type: "must_contain_regex", nb_inputs: 1, multiple: false, apply_to: ["string"]},
                {
                    type: "must_not_contain_regex",
                    nb_inputs: 1,
                    multiple: false,
                    apply_to: ["string"],
                },
                {
                    type: "must_not_contain_ordered_regex",
                    nb_inputs: 1,
                    multiple: false,
                    apply_to: ["string"],
                },
                {
                    type: "must_only_contain_regex",
                    nb_inputs: 1,
                    multiple: false,
                    apply_to: ["string"],
                },
                {
                    type: "must_contain_ordered_regex",
                    nb_inputs: 1,
                    multiple: false,
                    apply_to: ["string"],
                },
                {
                    type: "must_only_contain_ordered_regex",
                    nb_inputs: 1,
                    multiple: false,
                    apply_to: ["string"],
                },
                {type: "must_contain", nb_inputs: 1, multiple: false, apply_to: ["string"]},
                {type: "must_not_contain", nb_inputs: 1, multiple: false, apply_to: ["string"]},
                {
                    type: "must_not_contain_ordered",
                    nb_inputs: 1,
                    multiple: false,
                    apply_to: ["string"],
                },
                {type: "must_only_contain", nb_inputs: 1, multiple: false, apply_to: ["string"]},
                {
                    type: "must_contain_ordered",
                    nb_inputs: 1,
                    multiple: false,
                    apply_to: ["string"],
                },
                {
                    type: "must_only_contain_ordered",
                    nb_inputs: 1,
                    multiple: false,
                    apply_to: ["string"],
                },
                {type: "must_be_empty", nb_inputs: 0, multiple: false, apply_to: ["string"]},
            ],
            mongoOperators: {
                must_contain: (v) => ({must_contain: escapeRegExp(v[0])}),
                must_not_contain: (v) => ({must_not_contain: escapeRegExp(v[0])}),
                must_not_contain_ordered: (v) => ({must_not_contain_ordered: escapeRegExp(v[0])}),
                must_only_contain: (v) => ({must_only_contain: escapeRegExp(v[0])}),
                must_contain_ordered: (v) => ({must_contain_ordered: escapeRegExp(v[0])}),
                must_only_contain_ordered: (v) => ({
                    must_only_contain_ordered: escapeRegExp(v[0]),
                }),
                must_contain_regex: (v) => ({must_contain_regex: escapeRegExp(v[0])}),
                must_not_contain_regex: (v) => ({must_not_contain_regex: escapeRegExp(v[0])}),
                must_not_contain_ordered_regex: (v) => ({
                    must_not_contain_ordered_regex: escapeRegExp(v[0]),
                }),
                must_only_contain_regex: (v) => ({
                    must_only_contain_regex: "^" + escapeRegExp(v[0]),
                }),
                must_contain_ordered_regex: (v) => ({
                    must_contain_ordered_regex: escapeRegExp(v[0]),
                }),
                must_only_contain_ordered_regex: (v) => ({
                    must_only_contain_ordered_regex: escapeRegExp(v[0]),
                }),
                must_be_empty: () => ({must_be_empty: true}),
            },
            mongoRuleOperators: {
                must_contain: function (v) {
                    v = unEscapeRegExp(v);
                    return {val: v, op: "must_contain"};
                },
                must_not_contain: function (v) {
                    v = unEscapeRegExp(v);
                    return {val: v, op: "must_not_contain"};
                },
                must_not_contain_ordered: function (v) {
                    v = unEscapeRegExp(v);
                    return {val: v, op: "must_not_contain_ordered"};
                },
                must_only_contain: function (v) {
                    v = unEscapeRegExp(v);
                    return {val: v, op: "must_only_contain"};
                },
                must_contain_ordered: function (v) {
                    v = unEscapeRegExp(v);
                    return {val: v, op: "must_contain_ordered"};
                },
                must_only_contain_ordered: function (v) {
                    v = unEscapeRegExp(v);
                    return {val: v, op: "must_only_contain_ordered"};
                },
                must_contain_regex: function (v) {
                    v = unEscapeRegExp(v);
                    return {val: v, op: "must_contain_regex"};
                },
                must_not_contain_regex: function (v) {
                    v = unEscapeRegExp(v);
                    return {val: v, op: "must_not_contain_regex"};
                },
                must_not_contain_ordered_regex: function (v) {
                    v = unEscapeRegExp(v);
                    return {val: v, op: "must_not_contain_ordered_regex"};
                },
                must_only_contain_regex: function (v) {
                    v = unEscapeRegExp(v);
                    return {val: v, op: "must_only_contain_regex"};
                },
                must_contain_ordered_regex: function (v) {
                    v = unEscapeRegExp(v);
                    return {val: v, op: "must_contain_ordered_regex"};
                },
                must_only_contain_ordered_regex: function (v) {
                    v = unEscapeRegExp(v);
                    return {val: v, op: "must_only_contain_ordered_regex"};
                },
                must_be_empty: function (v) {
                    unEscapeRegExp(v);
                    return {op: "must_be_empty"};
                },
            },
            lang: {
                operators: {equal: "equal", not_equal: "not equal"},
            },
        };
        options.allow_groups = this._allowGroups;
        options.default_filter = this._model._type.column.field;
        options.plugins = ["sortable"];
        options.filters = _.uniqBy([this._model._type.column], "id");

        // options.plugins = ['sortable'];

        return options;
    }

    _setQuery(query) {
        const millisecondsToDays = (milliseconds) => milliseconds / (24 * 60 * 60 * 1000);

        const convertDurationToDays = (query) => {
            if (query.rules) {
                query.rules.forEach((rule) => {
                    convertDurationToDays(rule);
                });
            } else {
                // Check if the rule id is a duration
                if (
                    this._model._durationTypeFields.has(query.id) &&
                    query.operator !== "is_not_empty" &&
                    query.operator !== "is_empty"
                ) {
                    if (query.operator === "equal") {
                        const durationValue = _.get(query.value, "$gte", 0);
                        query.value =
                            typeof durationValue === "number"
                                ? millisecondsToDays(durationValue)
                                : 0;
                    } else if (query.operator === "not_equal") {
                        const durationValue = _.get(query.value, "$not.$lte", 0);
                        query.value =
                            typeof durationValue === "number"
                                ? millisecondsToDays(durationValue)
                                : 0;
                    } else if (query.value instanceof Array) {
                        query.value = query.value.map((val) =>
                            typeof val === "number" ? millisecondsToDays(val || 0) : val
                        );
                    } else if (typeof query.value === "number") {
                        query.value = millisecondsToDays(query.value || 0);
                    }
                }
            }
        };

        let newMongoQuery = _.cloneDeep(query);

        let rulesFromMongo = {};
        if (!_.isEmpty(newMongoQuery)) {
            rulesFromMongo = this.$builderContainer.queryBuilder(
                "getRulesFromMongo",
                newMongoQuery
            );
            convertDurationToDays(rulesFromMongo);
        }

        if (!_.isEmpty(rulesFromMongo) && rulesFromMongo.rules) {
            this.$builderContainer.queryBuilder("setRulesFromMongo", rulesFromMongo);
        } else {
            this._resetQueryBuilder();
        }
    }

    _resetQueryBuilder() {
        this.$builderContainer.queryBuilder("reset");
    }

    _applyQuery() {
        const mongoQuery = this.$builderContainer.queryBuilder("getMongo");
        if (this._isQueryEmpty() || this.$builderContainer.queryBuilder("validate")) {
            this._emitMongoQueryChanged(mongoQuery);
        }
    }

    _closeFilter() {
        this._emitCloseAdvancedFilter();
    }

    _isQueryEmpty({allow_invalid = true, skip_empty = true} = {}) {
        return !_.get(
            this.$builderContainer.queryBuilder("getRules", {allow_invalid, skip_empty}),
            "rules.length",
            0
        );
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /*******************************************/
}

module.exports = AdvancedFilterRenderer;
